import React, { useState, useEffect } from 'react';
import styles from './Jupiter.module.css';
import logoHero from './logo-simple.png';
import logoFooter from './logo-footer.png';
import logoDnda from './logo-dnda.png';
import logoSadaic from './logo-sadaic.png';
import logoRenaper from './logo-renaper.png';
import logoIconPurple from './logo-icon-purple.svg';
import logoIqAi from './iQ_AI_SEARCH_white.png';
import { BadgeIcon, BarChartIcon, DescriptionIcon, DrawIcon, GroupIcon, PublicIcon, StorageIcon, SupportAgentIcon } from "../../icons";
// El logo de marca vive en public/, adonde el generador lo copia desde el
// directorio brand/ del repo .haiku. Los otros siguen en src porque son
// ilustraciones de esta pagina, no la identidad del sistema.
const logoHeader = '/logo1.png';

const LANGUAGES = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
  { code: 'pt', label: 'PT' },
];

function JupiterPage({ onClick, currentLang = 'es', onLanguageChange }) {
  const [scrolled, setScrolled] = useState(false);
  const [overDark, setOverDark] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);

      // Detectar si el header está sobre una sección oscura
      const headerHeight = 72;
      const darkSections = document.querySelectorAll('[data-dark]');
      let isDark = false;
      darkSections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top < headerHeight && rect.bottom > 0) {
          isDark = true;
        }
      });
      setOverDark(isDark);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.page}>
      {/* Header */}
      <header className={`${styles.header} ${scrolled ? styles.scrolled : ''} ${overDark ? styles.headerDark : ''}`}>
        <img src={logoHeader} alt="Jupiter" className={styles.headerLogo} />
        <nav className={styles.headerNav}>
          <div className={styles.langSelector}>
            <span className={styles.langCurrent}>
              {currentLang.toUpperCase()}
              <span className={styles.langChevron}>&#9662;</span>
            </span>
            <div className={styles.langDropdown}>
              {LANGUAGES.filter(l => l.code !== currentLang).map(lang => (
                <span
                  key={lang.code}
                  className={styles.langOption}
                  onClick={() => onLanguageChange?.(lang.code)}
                  role="button"
                  tabIndex={0}
                >
                  {lang.label}
                </span>
              ))}
            </div>
          </div>
        </nav>
      </header>

      {/* Hero */}
      <section className={styles.hero}>
        <img src={logoHero} alt="Jupiter" className={styles.heroLogo} />
        <p className={styles.heroSubtitle}>
          PLATAFORMA CENTRALIZADA DE EDICIÓN MUSICAL
        </p>
        <p className={styles.heroDescription}>
          Administrá tu catálogo de obras desde un solo lugar y con total trazabilidad en cada operación.
        </p>
        <button className={styles.heroCta} onClick={onClick}>
          INICIAR SESIÓN
        </button>
        <div className={styles.heroTags}>
          <span>Contratos</span>
          <span>Registro de Obra</span>
          <span>Ediciones</span>
          <span>Firmas digitales</span>
        </div>
      </section>

      {/* Conectado con */}
      <section className={styles.partners}>
        <h3 className={styles.partnersTitle}>CONECTADA CON</h3>
        <div className={styles.partnersLogos}>
          <img src={logoDnda} alt="DNDA" className={styles.partnerLogo} />
          <img src={logoSadaic} alt="SADAIC" className={styles.partnerLogo} />
          <img src={logoRenaper} alt="RENAPER" className={styles.partnerLogo} style={{ marginLeft: 20, height: 87 }} />
        </div>
        <p className={styles.partnersQuote}>
          JUPITER es una nueva forma de gestionar derechos de autor.
        </p>
        <img src={logoIconPurple} alt="" className={styles.partnersIcon} />
      </section>

      {/* Features */}
      <section className={styles.features} data-dark>
        <h2 className={styles.featuresBanner}>TRAZABILIDAD Y TRANSPARENCIA</h2>
        <div className={styles.featuresInner}>
          <div className={styles.featureCard}>
            <StorageIcon className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Base de datos centralizada</h3>
            <p className={styles.featureDesc}>
              Autores, obras, ediciones, intérpretes, editoriales, contratos. Backups automáticos y trazabilidad de operaciones.
            </p>
          </div>
          <div className={styles.featureCard}>
            <DescriptionIcon className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Documentación Automatizada</h3>
            <p className={styles.featureDesc}>
              Confección automatizada de Contratos de Edición Musical, documentación adicional y personalizada.
            </p>
          </div>
          <div className={styles.featureCard}>
            <PublicIcon className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Registro de Obra</h3>
            <p className={styles.featureDesc}>
              Registro en TAD (DNDA), entrega a SADAIC, gestión en CRIN (Chile). Generación de CWR.
            </p>
          </div>
          <div className={styles.featureCard}>
            <DrawIcon className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>AgilSign</h3>
            <p className={styles.featureDesc}>
              Sistema nativo de Firmas Digitales e integración con DocuSign, Pandadoc, entre otros.
            </p>
          </div>
          <div className={styles.featureCard}>
            <img src={logoIqAi} alt="iQ AI Search" className={styles.featureIconImg} />
            <h3 className={styles.featureTitle}>iO: Asistente de IA</h3>
            <p className={styles.featureDesc}>
              Asistente de búsqueda y análisis de datos. Privado, seguro y personalizado.
            </p>
          </div>
          <div className={styles.featureCard}>
            <BarChartIcon className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Analytics y búsqueda de ONIs</h3>
            <p className={styles.featureDesc}>
              Dashboard, estadísticas, gráficos y búsqueda de obras no identificadas.
            </p>
          </div>
          <div className={styles.featureCard}>
            <GroupIcon className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Acceso Multi-usuario</h3>
            <p className={styles.featureDesc}>
              Acceso web y app de escritorio por roles: editores, visualizadores, data entry. Auditoría de actividad por usuario.
            </p>
          </div>
          <div className={styles.featureCard}>
            <BadgeIcon className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Validación de Datos Personales</h3>
            <p className={styles.featureDesc}>
              Validación de datos personales vía RENAPER, verificación de emails, carga automatizada de datos vía DNI.
            </p>
          </div>
          <div className={styles.featureCard}>
            <SupportAgentIcon className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Soporte</h3>
            <p className={styles.featureDesc}>
              Onboarding personalizado, actualizaciones permanentes y soporte técnico en español.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className={styles.ctaSection}>
        <h2 className={styles.ctaTitle}>COMENZA AHORA</h2>
        <p className={styles.ctaSubtitle}>Ingresá a JUPITER y gestioná tu catálogo como nunca antes</p>
        <a href="mailto:contacto@jupiter.com.ar" className={styles.ctaButton}>
          SOLICITAR ACCESO
        </a>
      </section>

      {/* Footer */}
      <footer className={styles.footer} data-dark>
        <div className={styles.footerInner}>
          <div className={styles.footerBrand}>
            <img src={logoFooter} alt="Jupiter - Trazabilidad y Transparencia" className={styles.footerLogo} />
          </div>
          <div className={styles.footerNav}>
            <button type="button" className={styles.footerLink}>Acerca de</button>
            <button type="button" className={styles.footerLink}>Contactanos</button>
            <button type="button" className={styles.footerLink}>Política de privacidad</button>
            <button type="button" className={styles.footerLink}>Términos y condiciones</button>
            <span className={styles.footerLink} onClick={onClick} role="button" tabIndex={0}>
              Iniciar sesión
            </span>
          </div>
        </div>
        <div className={styles.footerBottom}>
          © {new Date().getFullYear()} JUPITER. Todos los derechos reservados.
        </div>
      </footer>
    </div>
  );
}

export default JupiterPage;
